import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { ArchiveIcon, CalendarIcon, CameraIcon, CheckIcon, ClipboardCheckIcon, ClockIcon, EyeIcon, PaperClipIcon, PlusIcon, SelectorIcon, ShareIcon, TagIcon, TrashIcon, UserGroupIcon, XCircleIcon } from "@heroicons/react/solid";
import { Col, Row, Form, Modal, Button, InputGroup, Image, Badge, FloatingLabel, Accordion, OverlayTrigger, Tooltip, Card } from 'react-bootstrap';

import KanbanAvatar from "components/KanbanAvatar";
import { Members as BoardMembers, Labels as BoardLabels } from "data/kanban";
// import { DropImagesForm, DropVideosForm } from "./Forms";
import { MdAddBox, MdEdit, MdOutlineAddBox, MdOutlineSettings, MdOutlineVideocam, MdTextFields, MdVideoLibrary } from "react-icons/md";
import Select from 'react-select';
import { BsCartPlus, BsImageFill } from "react-icons/bs";
import { ImImages } from "react-icons/im";
import { IoDocumentTextOutline, IoLocationOutline } from "react-icons/io5";
import { LuClipboardList } from "react-icons/lu";
import { VscRobot } from "react-icons/vsc";
import { FaRedo, FaUserCircle } from "react-icons/fa";
import { FcPlus } from "react-icons/fc";
import { DropImagesForm, DropMediaFilesForm, DropVideosForm } from "./Forms";
import { FaList } from "react-icons/fa6";
import { GrDocumentText } from "react-icons/gr";
import { useGetStoredAPIsMutation } from "Services/services";


// previously on API sync
export const CreateSyncModal = (props) => {
  const { modalTitle = "ADD a New Sync", type = "card", show = false } = props;
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const onTitleChange = (e) => setTitle(e.target.value);
  const onDescriptionChange = (e) => setDescription(e.target.value);
  const onHide = () => props.onHide && props.onHide();

  const onSubmit = () => {
    const payload = { title, description };
    return props.onSubmit && props.onSubmit(payload);
  };

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={onHide}>
      <Form className="modal-content p-3">
        <Modal.Header className="pb-0 border-0">
          <h5 as={Modal.Title} className="fw-normal">
            {modalTitle}
          </h5>
          <Button variant="close" onClick={onHide} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Form.Group id="title" className="mb-3">
            <Form.Control
              required
              autoFocus
              type="text"
              value={title}
              onChange={onTitleChange}
              placeholder={`Enter a title for this ${type}…`}
            />
          </Form.Group>
          {type === "card" && (
            <Form.Group id="description" className="mb-3">
              <Form.Control
                required
                autoFocus
                multiple
                as="textarea"
                value={description}
                onChange={onDescriptionChange}
                placeholder={`Enter a description for this ${type}…`}
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0 pt-0">
          <Button variant="secondary" className="d-inline-flex align-items-center" onClick={onSubmit}>
            <PlusIcon className="icon icon-xs me-2" />
            Add Another Parameter
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

// on WhatsApp Template Creation - Form Button
export const CreateForm = (props) => {
  const { formTitle = `Form ${props.index + 1}`, show = false } = props;

  const onHide = () => props.onHide && props.onHide();

  const [addFieldModal, setAddFieldModal] = useState(false);
  const handleAddFieldToggle = () => {
    setAddFieldModal(true);
  };
  const oncloseModal2 = () => {
    setAddFieldModal(false);
  };
  const onSubmitModal2 = () => {
  };

  const [btn, setBtn] = useState('Continue');
  const HandleButton = (e) => {
    setBtn(e.target.value);
  }
  const [able, setAble] = useState(false);
  const handleBtnAction = () => {
    setAble(!able);
  }


  const [textFields] = useState({});


  const [fileFields, setFileFields] = useState({ image: null, video: null });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (e.target.name === 'image') {
      setFileFields((prevFields) => ({
        ...prevFields,
        image: file,
      }));
    } else if (e.target.name === 'video') {
      setFileFields((prevFields) => ({
        ...prevFields,
        video: file,
      }));
    }
  };

  const onSubmit = () => {
    const payload = {
      ...textFields,
      ...fileFields,
    };
    return (props.onSubmit && props.onSubmit(payload),
      props.onHide && props.onHide());
  };

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={onHide} size="xl">
      <div className="modal-content">
        <Modal.Header className="pb-0 border-bottom">
          <h5 as={Modal.Title} className="fw-normal">
            {/* {formTitle} */}
            Create Flow
          </h5>
          <Button variant="close" onClick={onHide} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Row>
            <Col xs={12} lg={8}>
              <Form className="py-3">
                <Form.Group as={Col} className="mb-3">
                  <Form.Label>Flow Name:</Form.Label>
                  <Form.Control type="text" required placeholder="name" maxLength={60} name="header" onChange={handleFileChange} value={formTitle} />
                </Form.Group>

                <Accordion defaultActiveKey="0" as={Col} className="mb-3">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Screen A</Accordion.Header>
                    <Accordion.Body>
                      <Form.Group as={Col} className="mb-3">
                        <Form.Label>Select Field</Form.Label>
                        <div className="d-flex">
                          <Form.Select name="field" >
                            <option defaultValue>Select</option>
                            <option>Large Text Heading</option>
                            <option>Image</option>
                          </Form.Select>
                          <Button variant="outline-gray-400" className="ms-2 d-inline-flex align-items-center" onClick={handleAddFieldToggle}>
                            <PlusIcon className="icon icon-xs" />
                          </Button>
                        </div>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column lg="2">
                          HEADING:
                        </Form.Label>
                        <Col lg="10" className="d-flex">
                          <FloatingLabel
                            label="Label"
                            className="w-100"
                          >
                            <Form.Control as="textarea" placeholder="Label" />
                          </FloatingLabel>
                          <Button variant="outline-danger" className="ms-2 d-inline-flex align-items-center">
                            <TrashIcon className="icon icon-xs" />
                          </Button>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column lg="2">
                          BUTTON:
                        </Form.Label>
                        <Col lg="10" className="d-flex">
                          {able ? <Form.Control type="text" required placeholder="button" maxLength={60} name="header" onChange={HandleButton} value={btn} />
                            : <Form.Control type="text" disabled placeholder="button" maxLength={60} name="header" onChange={HandleButton} value={btn} />}
                          <Button variant="outline-gray-400" onClick={handleBtnAction} className="ms-2 d-inline-flex align-items-center">
                            <MdEdit className="icon icon-xs" />
                          </Button>
                        </Col>
                      </Form.Group>

                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Button variant="outline-gray-700" color="dark" className="w-100">Add Another Screen</Button>

              </Form>
            </Col>
            <Col xs={4} lg={4}>
              <div className="img-cont">
                {/* <img src={whatsappFormPic} alt="whatsapp-form preview" /> */}
              </div>
            </Col>
            {/* <Form.Group as={Col}>
              <Form.Label>Card Header</Form.Label>
              <div className="d-flex flex-wrap">
                <Button onClick={handleHeader} variant={header === 'none' ? "secondary" : "gray-300"} value={"none"} className="m-2"><MdOutlineDoNotDisturbAlt /> None</Button>
                <Button onClick={handleHeader} variant={header === 'image' ? "secondary" : "gray-300"} value={"image"} className="m-2"><ImImages />  Image</Button>
                <Button onClick={handleHeader} variant={header === 'video' ? "secondary" : "gray-300"} value={"video"} className="m-2"><MdOutlineVideocam /> Video</Button>
              </div>
            </Form.Group> */}
          </Row>
          {/* {header === 'image' &&
            <Form.Group as={Col}>
              <DropImagesForm onFilesUploaded={handleFileChange} />
            </Form.Group>
          }
          {header === 'video' && 
            <Form.Group as={Col}>
              <DropVideosForm onFilesUploaded={handleFileChange} />
            </Form.Group>
          }
          <Row className="mt-3">
            <Form.Group as={Col}>
              <Form.Label>Card Body</Form.Label>
              <Form.Control as="textarea" rows="5" required placeholder="Enter Card Content" name="card_body" maxLength={160} onChange={handleTextChange}/>
            </Form.Group>
          </Row> */}
        </Modal.Body>
        <Modal.Footer className="justify-content-end border-0 mt-3">
          <Button variant="secondary" className="d-inline-flex align-items-center" onClick={onSubmit}>
            Save
          </Button>
          <Button variant="secondary" className="d-inline-flex align-items-center ms-2" onClick={onclose}>
            Cancel
          </Button>
        </Modal.Footer>
      </div>


      <Modal
        centered
        show={addFieldModal}
        onHide={oncloseModal2}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-content">
          <Modal.Header className="pb-0 border-bottom">
            <h5 className="fw-normal">
              Add Field
            </h5>
            <Button variant="close" onClick={oncloseModal2} />
          </Modal.Header>
          <Modal.Body className="pb-0">
            <Form className="py-3">
              <Form.Group as={Row} className="mb-3">
                <Form.Label column lg="5">
                  Display Name
                  <span className="text-danger"> * </span>
                </Form.Label>
                <Col lg="7">
                  <Form.Control type="text" placeholder="Enter Display Name" />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column lg="5">
                  Name
                  <span className="text-danger"> * </span>
                </Form.Label>
                <Col lg="7">
                  <Form.Control type="text" placeholder="Enter Field Name" />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column lg="5">
                  Type
                  <span className="text-danger"> * </span>
                </Form.Label>
                <Col lg="7">
                  <Form.Select aria-label="Default select example">
                    <option>Open this select menu</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Form.Select>
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3 ms-2">
                <Form.Check
                  type="checkbox"
                  id="required-checkbox"
                  label="Is Required"
                />
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Col>
                  <Form.Label>
                    Default Value
                    <span className="text-danger"> * </span>
                  </Form.Label>
                  <Form.Select aria-label="Default select example">
                    <option defaultChecked>False</option>
                    <option>True</option>
                  </Form.Select>
                </Col>
              </Form.Group>

            </Form>
          </Modal.Body>
          <Modal.Footer className="justify-content-end border-0 mt-3">
            <Button variant="secondary" className="d-inline-flex align-items-center" onClick={onSubmitModal2}>
              Save
            </Button>
            <Button variant="secondary" className="d-inline-flex align-items-center ms-2" onClick={oncloseModal2}>
              Cancel
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </Modal>
  );
};


export const EventModal = (props) => {
  const [title, setTitle] = useState(props.title);
  const [start, setStart] = useState(props.start);
  const [end, setEnd] = useState(props.end);

  const { show = false, edit = false, id } = props;
  const startDate = start ? moment(start).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
  const endDate = end ? moment(end).format("YYYY-MM-DD") : moment(start).format("YYYY-MM-DD");

  const onTitleChange = (e) => setTitle(e.target.value);

  const onConfirm = () => {
    const sameDay = startDate === endDate;
    const finalStart = sameDay ? moment(startDate).toDate() : moment(startDate).startOf('day').toDate();
    const finalEnd = sameDay ? null : moment(endDate).endOf('day').toDate();
    const payload = { id, title, sameDay, start: finalStart, end: finalEnd };

    if (edit) {
      return props.onUpdate && props.onUpdate(payload);
    }

    return props.onAdd && props.onAdd(payload);
  }
  const onDelete = () => edit && props.onDelete && props.onDelete(id);
  const onHide = () => props.onHide && props.onHide();

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={onHide}>
      <Form className="modal-content">
        <Modal.Body>
          <Form.Group id="title" className="mb-4">
            <Form.Label>Event title</Form.Label>
            <Form.Control
              required
              autoFocus
              type="text"
              value={title}
              onChange={onTitleChange} />
          </Form.Group>
          <Row>
            <Col xs={12} lg={6}>
              <Form.Group id="startDate">
                <Form.Label>Select start date</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={setStart}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text>
                        <CalendarIcon className="icon icon-xs" />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        placeholder="YYYY-MM-DD"
                        value={startDate}
                        onFocus={openCalendar}
                        onChange={() => { }} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
            <Col xs={12} lg={6}>
              <Form.Group id="endDate" className="mb-2">
                <Form.Label>Select end date</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={setEnd}
                  isValidDate={currDate => currDate.isSameOrAfter(start)}
                  initialViewDate={end || start}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text>
                        <CalendarIcon className="icon icon-xs" />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        placeholder="YYYY-MM-DD"
                        value={endDate}
                        onFocus={openCalendar}
                        onChange={() => { }} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="me-2" onClick={onConfirm}>
            {edit ? "Update event" : "Add new event"}
          </Button>

          {edit ? (
            <Button variant="danger" onClick={onDelete}>
              Delete event
            </Button>
          ) : null}

          <Button variant="link" className="text-gray ms-auto" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

//--------------------------------CHATBOT START---------------------------------------- 
export const UserInputModal = ({ isOpen, onClose, data, onSubmit, container }) => {
  const [inputfields, setInputfields] = useState({
    id: "",
    title: "",
    ResponseText: "",
    IsMedia: false,
    IsBotTerminate: false,
    IsUnknown: false,
    IsTrriggerFromAnywhere: false,
    IsEmailValidation: false,
    selectedVariable: null,
    AgentId: null,
    LabelId: null,
  });

  // Must have id for editing node,

  // Update input fields when `data` changes
  useEffect(() => {
    if (data && data.details) {
      setInputfields({
        id: data.details.id || "",
        title: data.details.data.title || "",
        ResponseText: data.details.data.ResponseText || "",
        IsMedia: data.details.data.IsMedia || false,
        IsUnknown: data.details.data.IsUnknown || false,
        IsTrriggerFromAnywhere: data.details.data.IsTrriggerFromAnywhere || false,
        IsBotTerminate: data.details.data.IsBotTerminate || false,
        IsEmailValidation: data.details.data.IsEmailValidation || false,
        selectedVariable: data.details.data.selectedVariable || null,
        AgentId: data.details.data.AgentId || null,
        LabelId: data.details.data.LabelId || null,
      });

    }
  }, [data, isOpen]);

  const handleInputs = (e) => {
    const { name, value, type, checked } = e.target;
    setInputfields((prevFields) => ({
      ...prevFields,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  if (!isOpen) return null;

  return (
    <Modal as={Modal.Dialog} centered show={isOpen} onHide={onClose} container={container}>
      <Form className="modal-content">
        <Modal.Header className="pb-0 border-0">
          <FaUserCircle style={{ width: "1.5em", height: "1.5em" }} />
          <h5 as={Modal.Title} className="ms-2 m-0">User Input</h5>
          <Button variant="close" onClick={onClose} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Title</Form.Label>
            <Form.Control
              required
              autoFocus
              type="text"
              name="title"
              value={inputfields.title}
              onChange={handleInputs}
              placeholder="Enter a title."
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Enter User Message</Form.Label>
            <Form.Control
              required
              as="textarea"
              name="ResponseText"
              value={inputfields.ResponseText}
              onChange={handleInputs}
              placeholder="Add Caption here.."
            />
          </Form.Group>
          {/* Switches */}
          <Form.Check
            type="switch"
            label="Is Media?"
            id="switch1"
            name="IsMedia"
            checked={inputfields.IsMedia}
            onChange={handleInputs}
          />
          <Form.Check
            type="switch"
            label="Terminate Bot?"
            id="switch2"
            name="IsBotTerminate"
            checked={inputfields.IsBotTerminate}
            onChange={handleInputs}
          />
          <Form.Check
            type="switch"
            label="Unknown Input?"
            id="switch3"
            name="IsUnknown"
            checked={inputfields.IsUnknown}
            onChange={handleInputs}
          />
          <Form.Check
            type="switch"
            label="Trigger From Anywhere?"
            id="switch4"
            name="IsTrriggerFromAnywhere"
            checked={inputfields.IsTrriggerFromAnywhere}
            onChange={handleInputs}
          />
          <Form.Check
            type="switch"
            label="Add Validation?"
            id="switch5"
            name="IsEmailValidation"
            checked={inputfields.IsEmailValidation}
            onChange={handleInputs}
          />
          {/* Select Inputs */}
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Save to a Variable?</Form.Label>
            <Select
              placeholder="Select ONE"
              className="mb-0"
              isSearchable
              value={inputfields.selectedVariable}
            // onChange={(selected) => setInputfields((prev) => ({ ...prev, selectedVariable: selected }))}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Select Agent?</Form.Label>
            <Select
              placeholder="Select ONE"
              className="mb-0"
              isSearchable
              value={inputfields.AgentId}
            // onChange={(selected) => setInputfields((prev) => ({ ...prev, AgentId: selected }))}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Select Label?</Form.Label>
            <Select
              placeholder="Select ONE"
              className="mb-0"
              isSearchable
              value={inputfields.LabelId}
            // onChange={(selected) => setInputfields((prev) => ({ ...prev, LabelId: selected }))}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="justify-content-end border-0 pt-2">
          <Button variant="outline-gray-500" onClick={onClose}>
            Close
          </Button>
          <Button variant="secondary" onClick={() => onSubmit(inputfields)}>
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const BotResponseModal = ({ isOpen, onClose, data, onSubmit, container }) => {
  const [inputfields, setInputfields] = useState({
    id: "",
    title: "",
    ResponseModels: []
  });
  const [extraFields, setExtraFields] = useState([]);    //for existing fields in case of edit


  // Update input fields when `data` changes
  useEffect(() => {

    if (data && data.details) {
      setInputfields({
        id: data.details.id || "",
        title: data.details.data.title || data.type,
        ResponseModels: data.details.data.ResponseModels || []
      });
      setExtraFields(data.details.data.ResponseModels);
    }
  }, [data, isOpen]);

  const handleInputs = (e) => {
    const { name, value } = e.target;
    setInputfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };

  // for new noed creation, NO existing fields
  const fields = {
    ResponseText: null,
    list: null,
    buttons: null,
    Product: null,
    Products: null,
    MediaFileName: null,
    ButtonType: "button",
    ButtonSubType: null,
  };

  const handleFieldChoice = (e) => {

    const MediaType = e.target.value;
    const newField = { MediaType, ...fields };

    if (!extraFields) {
      setExtraFields([newField]); // Appending new types of inputs
    } else {
      setExtraFields((prevFields) => [...prevFields, newField]); // Appending new types of inputs
    }

  };

  const handleInputChange = (targetIndex, target, value) => {
    setExtraFields((prevFields) =>
      prevFields.map((field, index) =>
        index === targetIndex ? 
    // (field.MediaType==='IMAGE'? { ...field, [target]: value, [preview]: preview} : { ...field, [target]: value} )

    { ...field, [target]: value}     : field
      )
    );
  };

  const deleteInputs = (indx) => {
    setExtraFields((prevFields) => prevFields.filter((_, index) => index !== indx));
  };
  // adding list
  const [modalType, setModalType] = useState(null);
  const [tempIndx, setTempIndx] = useState(null);
  const addList = (index) => {
    setTempIndx(index);
    setModalType('list');
  }
  // appending in main data
  const submittedLists = (newFields) => {
    setExtraFields((prevFields) =>
      prevFields.map((field, index) =>
        index === tempIndx ? { ...field, ...newFields } : field
      )
    );
    closeModal();
  }
  // adding buttons
  const addButton = (index) => {
    setTempIndx(index); //index of input where button is
    setModalType('button');
  }
  const closeModal = () => {
    setTempIndx(null);
    setModalType(false);
  };
  // appending in main data
  const submittedButtons = (newFields) => {
    setExtraFields((prevFields) =>
      prevFields.map((field, index) =>
        index === tempIndx ? { ...field, ...newFields } : field
      )
    );
    closeModal();
  }


  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedFinalFields = {
      ...inputfields,
      ResponseModels: [...extraFields]
    };

    onSubmit(updatedFinalFields);

  }



  if (!isOpen) return null;

  return (
    <Modal as={Modal.Dialog} centered show={isOpen} onHide={onClose} container={container}>
      <Form className="modal-content">
        <Modal.Header className="pb-0 border-0">
          <VscRobot style={{ width: '1.5em', height: '1.5em' }} />
          <h5 as={Modal.Title} className="ms-2 m-0">
            {data.type === 'botResponse' ? 'Bot Response' : data.type === 'start' ? 'Welcome Node' : 'Fallback'}
          </h5>
          <Button variant="close" onClick={onClose} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Title</Form.Label>
            <Form.Control
              required
              autoFocus
              type="text"
              name="title"
              value={inputfields.title}
              onChange={handleInputs}
              placeholder='Enter a title.'
            />
          </Form.Group>

          {extraFields && extraFields.map((field, index) => (
            <div key={index}>
              {field.MediaType === "TEXT" && (
                <div className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <div className="d-flex align-items-top mb-1">
                      <Form.Label className="mb-0">Enter Bot Response Text</Form.Label>
                      {(!field.buttons && !field.list) &&
                        <>
                          <Button onClick={() => addList(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success ms-auto fw-bold">
                            <FcPlus className="icon icon-xs me-2" />List
                          </Button>
                          <Button onClick={() => addButton(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold ms-2">
                            <FcPlus className="icon icon-xs me-2" />Button
                          </Button>
                        </>
                      }
                    </div>
                    <div>
                      <Form.Control
                        type="text"
                        required
                        placeholder='Enter Bot Response Text'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                    </div>
                    {field.list?.ListButtonText &&
                      <Button variant="info" className="mt-2 w-100 d-flex align-items-center justify-content-center">
                        <FaList className="me-2" />
                        {field.list.ListButtonText}
                      </Button>
                    }
                    {field.buttons &&
                      field.buttons.map((btn, indx) =>
                        <div key={indx}>
                          <Button variant="info" className="mt-2 w-100">
                            {btn.text || btn.label}
                          </Button>
                        </div>
                      )}
                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              )}
              {field.MediaType === "IMAGE" && (
                <div className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <div className="d-flex align-items-top mb-1">
                      <Form.Label className="mb-0">Add Image</Form.Label>
                      {!field.buttons && <Button onClick={() => addButton(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold ms-auto">
                        <FcPlus className="icon icon-xs me-2" />Button
                      </Button>}
                    </div>
                    <div>
                      {field.MediaFileName!==null ?
                         <span className="w-doc">
                         <BsImageFill className="icon icon-wide" />
                       </span>
                        :
                        <DropImagesForm onFilesUploaded={(e) => handleInputChange(index, "MediaFileName", e.target.value)} />
                      } 
                      <Form.Control
                        type="text"
                        required
                        placeholder='Add Caption here...'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                      {field.buttons &&
                        field.buttons.map((btn, indx) =>
                          <div key={indx}>
                            <Button variant="info" className="mt-2 w-100">
                              {btn.text}
                            </Button>
                          </div>
                        )}
                    </div>
                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              )}
              {field.MediaType === "VIDEO" && (
                <div className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <div className="d-flex align-items-top mb-1">
                      <Form.Label className="mb-0">Add Video</Form.Label>
                      {(!field.buttons && !field.list) &&
                        <>
                          <Button onClick={() => addList(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success ms-auto fw-bold">
                            <FcPlus className="icon icon-xs me-2" />List
                          </Button>
                          <Button onClick={() => addButton(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold ms-2">
                            <FcPlus className="icon icon-xs me-2" />Button
                          </Button>
                        </>
                      }
                    </div>
                    <div>
                      {field.MediaFileName!==null ?
                        <span className="w-doc">
                          <MdVideoLibrary className="icon icon-wide" />
                        </span>
                        :
                        <DropVideosForm onFilesUploaded={(e) => handleInputChange(index, "MediaFileName", e.target.value)} />
                      } 
                      <Form.Control
                        type="text"
                        required
                        placeholder='Add Caption here...'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                      {field.buttons &&
                        field.buttons.map((btn, indx) =>
                          <div key={indx}>
                            <Button variant="info" className="mt-2 w-100">
                              {btn.text}
                            </Button>
                          </div>
                        )}
                    </div>
                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              )}
              {field.MediaType === "DOC" && (
                <div className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <div className="d-flex align-items-top mb-1">
                      <Form.Label className="mb-0">Add Documents</Form.Label>
                      {(!field.buttons && !field.list) &&
                        <>
                          <Button onClick={() => addList(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success ms-auto fw-bold">
                            <FcPlus className="icon icon-xs me-2" />List
                          </Button>
                          <Button onClick={() => addButton(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold ms-2">
                            <FcPlus className="icon icon-xs me-2" />Button
                          </Button>
                        </>
                      }
                    </div>
                    <div>
                      {field.MediaFileName!==null ?
                        <span className="w-doc">
                         <GrDocumentText />
                        </span>
                        :
                        <DropMediaFilesForm onFilesUploaded={(e) => handleInputChange(index, "MediaFileName", e.target.value)} />
                      } 
                      <Form.Control
                        type="text"
                        required
                        placeholder='Add Caption here...'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                      {field.buttons &&
                        field.buttons.map((btn, indx) =>
                          <div key={indx}>
                            <Button variant="info" className="mt-2 w-100">
                              {btn.text}
                            </Button>
                          </div>
                        )}
                    </div>
                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              )}
              {field.MediaType === "PRODUCT" && (
                <div className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <div className="d-flex align-items-top mb-1">
                      <Form.Label className="mb-0">Single Product</Form.Label>
                      <Button onClick={() => addList(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success ms-auto fw-bold">
                        <FcPlus className="icon icon-xs me-2" />Product
                      </Button>
                    </div>
                    <div>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        required
                        placeholder="Body Text"
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                      <Form.Control
                        type="text"
                        required
                        placeholder='Footer Text'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                    </div>
                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              )}
              {field.MediaType === "PRODUCT_LIST" && (
                <div className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <div className="d-flex align-items-top mb-1">
                      <Form.Label className="mb-0">Multiple Products</Form.Label>
                      <Button onClick={() => addList(index)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success ms-auto fw-bold">
                        <FcPlus className="icon icon-xs me-2" />Products
                      </Button>
                    </div>
                    <div>
                      <Form.Control
                        type="text"
                        required
                        placeholder='Header Text'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                      <Form.Control
                        as="textarea"
                        rows="4"
                        required
                        placeholder="Body Text"
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                      <Form.Control
                        type="text"
                        required
                        placeholder='Footer Text'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                    </div>
                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              )}
              {field.MediaType === "LOCREQ" && (
                <div className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <div className="d-flex align-items-top mb-1">
                      <Form.Label className="mb-0">Enter Location Response Text</Form.Label>
                    </div>
                    <div>
                      <Form.Control
                        type="text"
                        required
                        placeholder='Enter Location Response Text'
                        value={field.ResponseText || ''}
                        onChange={(e) => handleInputChange(index, "ResponseText", e.target.value)}
                      />
                    </div>
                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              )}
            </div>
          ))}

          <div className="d-flex flex-wrap border-top mt-4">
            <Button variant="gray-300" value={"TEXT"} onClick={handleFieldChoice} className="m-2"><MdTextFields /> Text</Button>
            <Button variant="gray-300" value={"IMAGE"} onClick={handleFieldChoice} className="m-2"><ImImages />  Image</Button>
            <Button variant="gray-300" value={"VIDEO"} onClick={handleFieldChoice} className="m-2"><MdOutlineVideocam /> Video</Button>
            <Button variant="gray-300" value={"DOC"} onClick={handleFieldChoice} className="m-2"><IoDocumentTextOutline /> Document</Button>
            <Button variant="gray-300" value={"PRODUCT"} onClick={handleFieldChoice} className="m-2"><BsCartPlus /> Product</Button>
            <Button variant="gray-300" value={"PRODUCT_LIST"} onClick={handleFieldChoice} className="m-2"><LuClipboardList /> Product List</Button>
            <Button variant="gray-300" value={"LOCREQ"} onClick={handleFieldChoice} className="m-2"><IoLocationOutline /> Location Request</Button>
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-end border-0 pt-2">
          <Button variant="outline-gray-500" onClick={onClose}>
            Close
          </Button>
          <Button variant="secondary" className="" onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Form>

      {modalType === 'button' && <ButtonsModal isOpen={modalType} onClose={closeModal} onSubmit={submittedButtons} />}
      {modalType === 'list' && <ListModal isOpen={modalType} onClose={closeModal} onSubmit={submittedLists} />}

    </Modal>
  );
};

export const ButtonsModal = ({ isOpen, onClose, onSubmit, container }) => {

  const [type, setType] = useState('Buttons');
  const [buttonType, setButtonType] = useState('Quick Reply');
  const [buttons, setButtons] = useState([{ text: '' }]);
  const [validated, setValidated] = useState(false);


  const handleTypeChange = (e) => {
    const value = e.target.value;
    setButtonType(value);
    if (value === 'Visit Website') {
      setButtons([{ label: '', website: '' }]);
    } else if (value === 'Quick Reply') {
      setButtons([{ text: '' }]);
    }
  }

  // handle button data
  const handleButtons = (field, value, index) => {
    setButtons(prev => prev.map((btn, indx) => indx === index ? { ...btn, [field]: value } : btn));
  }
  const deleteCardButton = (index) => {
    setButtons(prev => prev.filter((_, indx) => indx !== index));
  }
  const addButtons = () => {
    if (buttons.length < 3) {
      setButtons(prev => [...prev, { text: '' }]);
    } else {
      alert("Maximum 3 buttons are allowed!");
    }
  }

  const submitAll = (e) => {
    e.preventDefault();
    // Prevent the default form submission
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    const payload = {
      ButtonType: type,
      ButtonSubType: buttonType,
      buttons: buttons
    }
    onSubmit(payload);
  }

  if (!isOpen) return null;

  return (
    <Modal as={Modal.Dialog} centered show={isOpen} onHide={onClose} container={container}>
      <Form className="modal-content" noValidate validated={validated} onSubmit={submitAll}>
        <Modal.Header className="pb-0 border-0">
          <MdAddBox style={{ width: '1.5em', height: '1.5em' }} />
          <h5 as={Modal.Title} className="ms-2 m-0">
            Add Buttons
          </h5>
          <Button variant="close" onClick={onClose} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Button Type</Form.Label>
            <Select
              value={{ value: type, label: type }}
              onChange={option => setType(option.value)}
              options={[
                { value: 'Buttons', label: 'Buttons' },
                { value: 'Flow', label: 'Flow' },
              ]}
              className="w-100"
            />
          </Form.Group>

          {type === 'Buttons' &&
            <>
              <Form.Group className="mb-3">
                <Form.Label className="mb-0">Button Sub Type</Form.Label>
                <Select
                  value={{ value: buttonType, label: buttonType }}
                  onChange={option => handleTypeChange({ target: { value: option.value } })}
                  options={[
                    { value: 'Quick Reply', label: 'Quick Reply' },
                    { value: 'Visit Website', label: 'Visit Website' },
                  ]}
                  className="w-100"
                />
              </Form.Group>

              <Form.Label className="mb-0">Button</Form.Label>
              {buttonType === "Quick Reply" && (
                <div className="my-2">
                  <div className="d-flex align-items-start justify-content-between">
                    <Form.Label className="mb-0">Quick Reply</Form.Label>
                    <Button onClick={addButtons} type="button" bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit", textWrap: 'nowrap', width: 'min-content' }} variant="secondary" className="text-success fw-bold">
                      <MdOutlineAddBox className="icon icon-xs" /> Add Buttons
                    </Button>
                  </div>
                  {buttons.map((btn, index) => (
                    <Form.Group key={index} className="d-flex align-items-center mb-2">
                      <Form.Control
                        type="text"
                        required
                        placeholder='Text Button'
                        value={btn.text}
                        onChange={(e) => handleButtons('text', e.target.value, index)}
                      />
                      <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Button</Tooltip>}>
                        <Card.Link className="ms-2" onClick={() => deleteCardButton(index)}>
                          <XCircleIcon className="icon icon-xs text-danger" />
                        </Card.Link>
                      </OverlayTrigger>
                    </Form.Group>
                  ))}
                </div>
              )}

              {(buttonType === "Visit Website") && (
                <Row className="my-2">
                  <Form.Label className="mb-0">Website URL</Form.Label>
                  {buttons.map((btn, index) => (
                    <Row key={index}>
                      <Col md={4} className="pe-0">
                        <Form.Control
                          type="text"
                          required
                          placeholder={`Button text`}
                          value={btn.label}
                          onChange={(e) => handleButtons('label', e.target.value, index)}
                        />
                      </Col>
                      <Col md={7} className="pe-0">
                        <Form.Control
                          type="url"
                          required
                          placeholder="https://example.com"
                          value={btn.website}
                          onChange={(e) => handleButtons('website', e.target.value, index)}
                        />
                      </Col>
                      <Col md={1} className="d-flex align-items-center">
                        <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Button</Tooltip>}>
                          <Card.Link onClick={() => deleteCardButton(index)}>
                            <XCircleIcon className="icon icon-xs text-danger" />
                          </Card.Link>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  ))}
                </Row>
              )}
            </>
          }

          {type === 'Flow' &&
            <>
              <Form.Group className="mb-3">
                <Form.Label className="mb-0">Select Flow</Form.Label>
                <Select
                  // options={flowOptions}
                  placeholder="Select flow"
                  className="mb-0"
                  isSearchable={true}
                  name="flow"
                // value={flowOptions.find(option => option.value === inputfields.selectedVariable)} // Ensure correct option is selected
                // onChange={(selectedOption, actionMeta) => handleInputs(selectedOption, actionMeta)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="mb-0">Button Text</Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Button text"
                // value={btn.label}
                // onChange={(e) => handleButtons('label', e.target.value, index)}
                />
              </Form.Group>
            </>
          }

        </Modal.Body>

        <Modal.Footer className="justify-content-end border-0 pt-2">
          <Button variant="outline-gray-500" onClick={onClose} type="button">
            Close
          </Button>
          <Button variant="secondary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const ListModal = ({ isOpen, onClose, onSubmit, container }) => {
  const [list, setList] = useState({
    ListButtonText: "",
    SelectedListVariable: null,
    IsGetListFromVariable: false,
    UserInputKeyword: "",
  });
  const handleList = (field, value) => {
    setList((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (field === 'IsGetListFromVariable' && value === true) {
      setSection([]);
    }
  };
  const handleSelect = (selectedOption) => {
    setList((prev) => ({
      ...prev,
      SelectedListVariable: selectedOption?.value,
    }));
  }
  const [section, setSection] = useState([
    {
      sectionText: '',
      buttons: [
        {
          title: '',
          description: ''
        }]
    }
  ]);
  const addSection = () => {
    setSection((prev) => [
      ...prev,
      {
        sectionText: '',
        buttons: [{
          title: '',
          description: ''
        }]
      }
    ]);
  }
  const handleInputs = (field, value, index) => {
    setSection((prev) =>
      prev.map((item, i) => i === index ?
        {
          ...item,
          [field]: value,
        }
        : item
      )
    );
  };
  const deleteInputs = (index) => {
    const updatedSection = section.filter((_, i) => i !== index);
    setSection(updatedSection);
  };

  // ADDING BUTTONS
  const addOptions = (sectnIndx) => {
    setSection((prev) =>
      prev.map((sec, index) =>
        index === sectnIndx
          ? {
            ...sec,
            buttons: [
              ...sec.buttons,
              {
                title: '',
                description: ''
              }
            ]
          }
          : sec
      )
    )
  }

  const handleBtns = (field, value, btnIndex, secIndex) => {
    setSection((prev) =>
      prev.map((sec, secId) =>
        secId === secIndex
          ? {
            ...sec,
            buttons: sec.buttons.map((btn, bId) =>
              bId === btnIndex
                ? { ...btn, [field]: value }
                : btn
            ),
          }
          : sec
      )
    );
  };

  const deleteOptions = (bId, secId) => {
    const updatedSection = section.map((sec, i) => i === secId ? { ...sec, buttons: sec.buttons.filter((_, id) => id !== bId) } : sec);
    setSection(updatedSection);
  };

  const [validated, setValidated] = useState(false);

  const [recieveNew, setRecieveNew] = useState(false);
  // select var functionality
  const [varOptions, setVarOptions] = useState([
    { value: 'new', label: <div onClick={() => setRecieveNew(true)}>Add New Option</div> },
  ]);

  const [optNew, setOptNew] = useState('');
  const addOption = () => {
    if (optNew !== '') {
      setVarOptions((prev) => ([
        ...prev,
        { value: optNew, label: optNew }
      ]))
      setRecieveNew(false);
    }
  }

  const submitAll = (e) => {
    e.preventDefault();
    // Prevent the default form submission
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    const payload = {
      list: {
        ...list,
        ListValue: section,
      },
    }

    onSubmit(payload);
  }

  if (!isOpen) return null;

  return (
    <Modal as={Modal.Dialog} centered show={isOpen} onHide={onClose} container={container}>
      <Form className="modal-content" noValidate validated={validated} onSubmit={submitAll}>
        <Modal.Header className="pb-0 border-0">
          <MdAddBox style={{ width: '1.5em', height: '1.5em' }} />
          <h5 as={Modal.Title} className="ms-2 m-0">
            Add List
          </h5>
          <Button variant="close" onClick={onClose} />
        </Modal.Header>

        <Modal.Body className="pb-0">
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">List Button Text</Form.Label>
            <Form.Control
              type="text"
              required
              placeholder='List Text Button'
              value={list.ListButtonText}
              onChange={(e) => handleList('ListButtonText', e.target.value)}
            />
          </Form.Group>

          <Form.Check
            type="switch"
            label="Get List from Variable?"
            id="switch1"
            checked={list.IsGetListFromVariable}
            onChange={(e) => handleList('IsGetListFromVariable', e.target.checked)}
          />


          {list.IsGetListFromVariable ?

            <>
              <Form.Control
                type="text"
                // required
                placeholder='please enter user input keyword'
                value={list.UserInputKeyword || ''}
                onChange={(e) => handleList('UserInputKeyword', e.target.value)}
              />

              <Form.Group className="mt-3">
                <Form.Label className="mb-0">Save to a variable</Form.Label>
                <Select
                  options={varOptions}
                  placeholder="Select"
                  className="mb-0"
                  isSearchable={true}
                  // name="SelectedListVariable"
                  value={varOptions.find(option => option.value === list.SelectedListVariable)} // Ensure correct option is selected
                  onChange={(selectedOption) => handleSelect(selectedOption)}
                />
              </Form.Group>

              {recieveNew &&
                <>
                  <Form.Control
                    type="text"
                    required
                    className="mt-3"
                    placeholder='please enter user input keyword'
                    onChange={(e) => setOptNew(e.target.value)}
                  />
                  <Button variant="warning" type="button" className="mt-2" onClick={addOption}>
                    Add
                  </Button>
                </>
              }

            </>

            :

            <>
              <Button variant="warning" type="button" className="mt-2" onClick={addSection}>
                Add Section
              </Button>

              {section.map((field, index) => (
                <div key={index} className="d-flex my-2">
                  <div className="card light input-card w-100 p-2 m-0">
                    <Form.Group className="mb-3">
                      <Form.Label className="mb-0">Section Text</Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder='Section Text'
                        value={field.sectionText || ''}
                        onChange={(e) => handleInputs('sectionText', e.target.value, index)}
                      />
                    </Form.Group>

                    <div className="d-flex justify-content-between mb-2">
                      <Form.Label>Buttons</Form.Label>
                      <Button onClick={() => addOptions(index)} type="button" bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit", textWrap: 'nowrap', width: 'min-content' }} variant="secondary" className="text-success d-flex align-items-center fw-bold">
                        <MdOutlineAddBox className="icon icon-xs" />
                        Add Option
                      </Button>
                    </div>

                    {field.buttons && field.buttons.map((btn, btnIndex) => (
                      <Form.Group key={btnIndex} className="mb-3">
                        <div className="d-flex">
                          <Form.Label className="mb-0">Option</Form.Label>
                          <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Button</Tooltip>}>
                            <Card.Link className="ms-auto" onClick={() => deleteOptions(btnIndex, index)}>
                              <XCircleIcon className="icon icon-xs text-danger" />
                            </Card.Link>
                          </OverlayTrigger>
                        </div>
                        <Form.Control
                          type="text"
                          required
                          placeholder='Option title'
                          value={btn.title || ''}
                          onChange={(e) => handleBtns('title', e.target.value, btnIndex, index)}
                        />
                        <Form.Control
                          type="text"
                          // required
                          className="mt-2"
                          placeholder='Description'
                          value={btn.description || ''}
                          onChange={(e) => handleBtns('description', e.target.value, btnIndex, index)}
                        />
                      </Form.Group>
                    ))}

                  </div>
                  <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete Input</Tooltip>}>
                    <Card.Link className="ms-2" onClick={() => deleteInputs(index)}>
                      <XCircleIcon className="icon icon-xs text-danger" />
                    </Card.Link>
                  </OverlayTrigger>
                </div>
              ))}
            </>
          }

        </Modal.Body>

        <Modal.Footer className="justify-content-end border-0 pt-2">
          <Button variant="outline-gray-500" onClick={onClose} type="button">
            Close
          </Button>
          <Button variant="secondary" type="submit" >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const APIModal = ({ isOpen, onClose, data, onSubmit, container }) => {
  const [storedAPIs] = useGetStoredAPIsMutation();
  const [apiNames, setApiNames] = useState([]);
  const [apiDataset, setApiDataset] = useState([]);
  const [varOptions, setVarOptions] = useState([]);
  const [isDeleted, setIsDeleted] = useState(false);


  const [inputfields, setInputfields] = useState({
    id: "",
    title: "",
    apiId: null,
    selectedVariable: [],
  });

  // Update input fields when `data` changes
  useEffect(() => {
    fetchTableData();

    if (data && data.details) {
      setInputfields({
        id: data.details.id || "",
        title: data.details.data.title || "",
        apiId: data.details.data.apiId || '',
        selectedVariable: data.details.data.selectedVariable || '',
      });
    }

  }, [data, isOpen]);

  useEffect(()=> {
    if (!inputfields.apiId || apiDataset.length===0){
      return;
    } else {
      const findVariable = apiDataset.filter((item)=>(item.id===inputfields.apiId))
      if (findVariable.length===0){
        setIsDeleted(true);
        setInputfields(prev=>({...prev, apiId: '', selectedVariable: []}))
        return;
      } else {
        const varOptions = findVariable[0].chatbot_details.map((items)=>({
          label: items.chatbotVariable,
          value: items.outputType,
        }))
        setVarOptions(varOptions);
      }
     
    }
  }, [inputfields, apiDataset])

  const fetchTableData = () => {
    storedAPIs({
      page: 1,
      limit: '',
      search: '',
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          let data = response?.data?.data.items;
          setApiDataset(data);
          let apis = data.map((item)=>({label:item.api_name, value: item.id}))
          setApiNames(apis);
        } else {
          setApiNames([]);
          setApiDataset([]);
        }
      })
      .catch(() => {
        setApiNames([]);
        setApiDataset([]);
      });
  };

  const handleInputs = (eventOrSelectedOption, actionMeta) => {
    if (actionMeta) {
      // Handling react-select
      const { name } = actionMeta;
      setInputfields((prev) => ({
        ...prev,
        [name]: eventOrSelectedOption?.value, // Update the selected value
      }));
    } else {
      // Handling regular input fields
      const { name, value } = eventOrSelectedOption.target;
      setInputfields((prev) => ({
        ...prev,
        [name]: value, // Update input field value
      }));
    }
  };

  if (!isOpen) return null;

  return (
    <Modal as={Modal.Dialog} centered show={isOpen} onHide={onClose} container={container}>
      <Form className="modal-content">
        <Modal.Header className="pb-0 border-0">
          <MdOutlineSettings style={{ width: '1.5em', height: '1.5em' }} />
          <h5 as={Modal.Title} className="ms-2 m-0">
            Add API
          </h5>
          <Button variant="close" onClick={onClose} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Title</Form.Label>
            <Form.Control
              required
              autoFocus
              type="text"
              name="title"
              value={inputfields.title}
              onChange={handleInputs}
              placeholder='Enter a title.'
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Select API?</Form.Label>
            <Select
              options={apiNames}
              placeholder="Select ONE"
              className="mb-0"
              isSearchable={true}
              name="apiId"
              value={apiNames.find(option => option.value === inputfields.apiId || '')} 
              onChange={(selectedOption, actionMeta) =>{ handleInputs(selectedOption, actionMeta); setIsDeleted(false);}}
            />
          </Form.Group>
          {isDeleted && <div className="text-danger">API not found! Select a new One?</div>}
          {(varOptions.length>0) && <Form.Group className="mb-3">
            <Form.Label className="mb-0">Save to a Variable?</Form.Label>
            <Select
              options={varOptions}
              isMulti
              placeholder="Select ONE"
              className="mb-0"
              isSearchable={true}
              name="selectedVariable"
              value={inputfields.selectedVariable} 
              onChange={(selectedOptions) => setInputfields(prev=>({...prev,  selectedVariable: selectedOptions || []}))}
            />
          </Form.Group>}
        </Modal.Body>

        <Modal.Footer className="justify-content-end border-0 pt-2">
          <Button variant="outline-gray-500" onClick={onClose}>
            Close
          </Button>
          <Button variant="secondary" className="" onClick={() => onSubmit(inputfields)}>
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const LoopbackModal = ({ isOpen, onClose, data, onSubmit, container }) => {
  const [inputfields, setInputfields] = useState({
    id: "",
    title: "",
    loopbackNodeId: ""
  });

  // Update input fields when `data` changes
  useEffect(() => {
    if (data && data.details) {
      setInputfields({
        id: data.details.id || "",
        title: data.details.data.title || "",
        loopbackNodeId: data.details.data.loopbackNodeId || ''
      });
    }
  }, [data, isOpen]);

  const options = JSON.parse(localStorage.getItem('optionsBack')) || [{}];

  const handleInputs = (eventOrSelectedOption, actionMeta) => {
    if (actionMeta) {
      // Handling react-select
      const { name } = actionMeta;
      setInputfields((prev) => ({
        ...prev,
        [name]: eventOrSelectedOption?.value, // Update the selected value
      }));
    } else {
      // Handling regular input fields
      const { name, value } = eventOrSelectedOption.target;
      setInputfields((prev) => ({
        ...prev,
        [name]: value, // Update input field value
      }));
    }
  };

  if (!isOpen) return null;

  return (
    <Modal as={Modal.Dialog} centered show={isOpen} onHide={onClose} container={container}>
      <Form className="modal-content">
        <Modal.Header className="pb-0 border-0">
          <FaRedo style={{ width: '1.5em', height: '1.5em' }} />
          <h5 as={Modal.Title} className="ms-2 m-0">
            Add API
          </h5>
          <Button variant="close" onClick={onClose} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Title</Form.Label>
            <Form.Control
              required
              autoFocus
              type="text"
              name="title"
              value={inputfields.title}
              onChange={handleInputs}
              placeholder='Enter a title.'
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Select Loopback Node:</Form.Label>
            <Select
              options={options}
              placeholder="Select ONE"
              className="mb-0"
              isSearchable={true}
              name="loopbackNodeId"
              value={options.find(option => option.value === inputfields.loopbackNodeId)} // Ensure correct option is selected
              onChange={(selectedOption, actionMeta) => handleInputs(selectedOption, actionMeta)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="justify-content-end border-0 pt-2">
          <Button variant="outline-gray-500" onClick={onClose}>
            Close
          </Button>
          <Button variant="secondary" className="" onClick={() => onSubmit(inputfields)}>
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};


//--------------------------------CHATBOT END---------------------------------------- 
